/**
 * A cor da barra do sistema (onde ficam a hora e a bateria) em cada tema.
 *
 * É a do `themeColor` do `app/layout.tsx` no escuro, e quem a mantém na
 * `meta[name=theme-color]` é o `CorDaBarra`, no `ThemeProvider`. A casca do
 * celular lê esta cor (pela meta e pelo aviso `THEME_UPDATE`) para decidir a cor
 * da hora e dos ícones: sobre cor clara eles saem escuros, sobre escura, claros.
 */
export const COR_DA_BARRA = { light: "#F7F7F7", dark: "#0A0A0A" } as const

/**
 * A cor da barra do tema que está NA TELA agora.
 *
 * Vem da classe que o `next-themes` põe no `<html>`, que já junta a escolha da
 * pessoa e o tema forçado da rota (a porta escura, a página externa clara).
 */
export function corDaBarraNaTela(): string {
  return document.documentElement.classList.contains("light")
    ? COR_DA_BARRA.light
    : COR_DA_BARRA.dark
}
